import { useModalStore } from '@/shared/lib';
import { SecurityAndPrivacyModal } from '../ui/SecurityAndPrivacyModal';

interface Props {
  onBack: () => void;
}

const useSecurityAndPrivacy = () => {
  const { showDialogComponent } = useModalStore();

  const openSecurityAndPrivacyModal = ({ onBack }: Props) => {
    showDialogComponent({
      component: (
        <SecurityAndPrivacyModal
          onBack={onBack}
          returnToCurrentScreen={() => openSecurityAndPrivacyModal({ onBack })}
        />
      ),
      className: 'bg-secondary-bg',
    });
  };

  return { openSecurityAndPrivacyModal };
};

export { useSecurityAndPrivacy };
